









import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class CounponButton extends Vue {
  @Prop({ default: 'default' }) type!: 'default' | 'light';
  @Prop() text!: string;

  @Emit('click')
  onClick(e: Event) {
    return e;
  }
}
